import { useMsal } from "@azure/msal-react";
import { Flex, Main } from "@hopper-ui/components";
import { PageLoader } from "@sg-protect/components";
import { Header, RegionPicker, RegionSelectionModal } from "@sg-protect/shell";
import { type PropsWithChildren, Suspense, useCallback } from "react";
import { Outlet, useLocation } from "react-router";
import { Routes } from "../../constants.ts";
import { clearGoogleToken } from "../google/GoogleProvider.tsx";
import { UserMenu } from "../UserMenu.tsx";

const NavBarHeight = "4.5rem";

export const AuthenticatedLayout = ({ children = <Outlet /> }: PropsWithChildren) => {
    const { instance } = useMsal();
    const location = useLocation();

    const onRegionChange = useCallback(async () => {
        await instance.clearCache();
        clearGoogleToken();
    }, [instance]);

    const picker = location.pathname === Routes.assessment ? <RegionPicker onRegionChange={onRegionChange} /> : null;

    return (
        <>
            <RegionSelectionModal />
            <Header href={Routes.assessment} headerWidget={picker} userMenu={<UserMenu />} />
            <Flex>
                <Main UNSAFE_minHeight={`calc(100dvh - ${NavBarHeight})`} id="main-content" width="100%">
                    <Suspense fallback={<PageLoader aria-label="Loading page…" />}>{children}</Suspense>
                </Main>
            </Flex>
        </>
    );
};
